<!--
 * @Author: mzw
 * @Date: 2021-09-28 17:29:30
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-07-31 21:31:39
 * @Description: 商品列表组件
-->
<template>
  <div class="product-box">
    <el-col :span="24" class="product-list">
      <el-table
        ref="goodsTable"
        :show-header="showHeader"
        :data="productData"
        size="small"
        :header-cell-style="{ background: '#f9f9f9' }"
        :span-method="objectSpanMethod"
      >
        <!-- <el-table-column type="index" width="50" align="center"></el-table-column> -->
        <el-table-column
          prop="img"
          label=""
          header-align="center"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <div v-if="!scope.row.proMore3Len" class="imgBox">
              <img
                :src="scope.row.goodsUrl"
                v-show="scope.row.goodsUrl"
                alt=""
                width="80px"
                height="80px"
              />
              <img
                src="~@/assets/img/bitmap.png"
                v-show="!scope.row.goodsUrl"
                alt=""
                width="80px"
                height="80px"
              />
            </div>
            <div
              v-else
              @click.stop="detailOrderHandle(orderJson, true)"
              class="proMore"
            >
              展开其他{{ scope.row.proMore3Len }}件<i
                class="el-icon-arrow-down"
              ></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" width="220">
          <template slot-scope="scope">
            <div class="product-info" v-if="!scope.row.proMore3Len">
              <p>{{ scope.row.goodsName }}</p>
              <span>{{ $t("product.codes") }}：{{ scope.row.goodsCode }}</span>
              <span>{{ $t("common.model") }}：{{ scope.row.goodsModel }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsNum"
          :label="$t('common.quantity')"
          width="85"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="$t('order.unitPrice')"
          width="90"
          align="center"
        >
          <template slot-scope="scope" v-if="!scope.row.proMore3Len">
            <span :label="scope.row.goodsPrice">{{
              scope.row.originalTransactionPrice
                ? scope.row.originalTransactionPrice.toFixed(2)
                : "0.00"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('orderlist.total')"
          width="200"
          class-name="merge-item"
        >
          <template>
            <span
              >{{ $t("order.productAmount") }}：{{ $t("common.currency")
              }}{{
                orderJson.payMoney ? orderJson.payMoney.toFixed(2) : "0.00"
              }}</span
            >
            <span
              >{{ $t("order.discount") }}：{{ $t("common.currency")
              }}{{
                orderJson.discountAmount
                  ? orderJson.discountAmount.toFixed(2)
                  : "0.00"
              }}</span
            >
            <span
              >{{ $t("order.shipping") }}：{{ $t("common.currency")
              }}{{
                orderJson.expressFee ? orderJson.expressFee.toFixed(2) : "0.00"
              }}</span
            >
            <span
              >{{ $t("order.payable") }}：{{ $t("common.currency")
              }}{{
                orderJson.totalPay ? orderJson.totalPay.toFixed(2) : "0.00"
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('orderlist.orderStatus')"
          width="125"
          class-name="merge-item"
        >
          <template slot-scope="scope">
            <!-- 发货状态 -->
            <span v-if="Number(orderJson.orderStatus) <= 50">{{
              $t("orderlist.orderStatusOpt2")
            }}</span>
            <span v-else style="white-space:nowrap">{{
              $getDictLabel("NEW_ORDER_STATUS", orderJson.orderStatus)
            }}</span>
            <!-- 支付状态 orderStatus:90已取消-->
            <span
              class="status-tip"
              v-if="Number(orderJson.orderStatus) != 90"
              >{{
                $getDictLabel("ORDER_PAY_STATUS", orderJson.payStatus)
              }}</span
            >
            <!-- 开票状态 -->
            <span v-if="invoiceMap[orderJson.invoiceStatus]">
              <span v-if="['10', '20'].includes(orderJson.invoiceStatus)">
                <span
                  class="blue-tip"
                  @click="toInvoiceAdd(orderJson)"
                  >去开票</span
                >
              </span>
              <span v-if="['30'].includes(orderJson.invoiceStatus)">
                全部开票
              </span>
            </span>
            <span class="blue-tip" @click.stop="detailOrderHandle(scope.row)">{{
              $t("orderlist.orderDetail")
            }}</span>
            <span
              class="blue-tip"
              @click.stop="detailOrderHandle(scope.row, true)"
              v-if="
                Number(orderJson.orderStatus) >= 60 &&
                  Number(orderJson.orderStatus) <= 80
              "
              >{{ $t("orderlist.btn1") }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('handle')"
          width="125"
          class-name="merge-item"
        >
          <template slot-scope="scope">
            <!-- 部分支付payStatus:22及其前所有状态都不展示 -->
            <el-button
              type="done"
              @click.stop="goToPay()"
              v-if="
                Number(orderJson.payStatus) < '22' &&
                  orderJson.orderStatus != '90'
              "
              >立即支付</el-button
            >
            <!-- 除了已取消 都能查看合同 -->
            <!-- <el-button
              type="look"
              @click.stop="downloadContract()"
              v-if="orderJson.orderStatus != '90'"
              >查看合同</el-button
            > -->
            <!-- <el-button
              type="done"
              @click.stop="buyAgain()"
              v-if="Number(orderJson.orderStatus) >= 80"
              >{{ $t("orderlist.btn4") }}</el-button
            > -->
            <!-- 只有orderStatus:10待支付/待提审 才能取消 -->
            <el-button
              type="cancle"
              @click.stop="cancelOrderHandle(scope.row)"
              v-if="orderJson.orderStatus == '10'"
              >{{ $t("orderlist.btn5") }}</el-button
            >
            <!-- 只有orderStatus:80已完成 才能评价-->
            <el-button
              type="done"
              style="min-width: 70px;"
              v-if="orderJson.orderStatus == '80' && !orderJson.evaluated"
              @click.stop="orderEvaluate(orderJson)"
              >{{ $t("orderlist.btn6") }}</el-button
            >
            <el-button
              type="done"
              v-if="orderJson.orderStatus == '80' && orderJson.evaluated"
              @click.stop="showOrderEvaluate(orderJson)"
              >{{ $t("orderlist.btn7") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-col>
    <el-dialog
      :title="$t('ordervote.title')"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible"
      top="4vh"
      width="770px"
    >
      <OrderEvaluate
        v-if="dialogVisible"
        @close="dialogVisible = false"
        @success="onSuccess"
        :detail="row"
      />
    </el-dialog>
    <el-dialog
      :title="$t('ordervote.view')"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible2"
      top="4vh"
      width="770px"
    >
      <OrderEvaluateShow
        v-if="dialogVisible2"
        @close="dialogVisible2 = false"
        :detail="row"
      />
    </el-dialog>
  </div>
</template>
<script>
import OrderEvaluate from './orderEvaluate.vue'
import OrderEvaluateShow from './orderEvaluateShow.vue'
export default {
  components: {
    OrderEvaluate,
    OrderEvaluateShow
  },
  data () {
    return {
      row: {},
      dialogVisible: false,
      dialogVisible2: false,
      invoiceMap: {
        10: '未开票',
        20: '部分开票',
        30: '全部开票',
      }
    }
  },
  props: {
    productList: {
      type: Array,
      default: () => {
        return []
      }
    },
    showHeader: {
      // 是否展示表头
      type: Boolean
    },
    orderJson: {
      type: Object
    }
  },
  computed: {
    productData () {
      if (this.productList.length > 3) {
        // 若超过三件商品，则仅保留三件、并在表格显示其他剩余条数
        let newList = this.productList.slice(0, 3)
        newList.push({
          proMore3Len: this.productList.length - 3
        })
        return newList
      } else {
        return this.productList
      }
      // return this.productList
    }
  },
  watch: {
    productData: {
      handler (n, o) {
        this.getSpanArr(this.productData)
      },
      immediate: true
    }
  },
  methods: {
    toInvoiceAdd (info) {
      if (!['22', '29'].includes(info.payStatus)) {
        return this.$message.warning('暂不可申请，请联系客服！')
      }
      this.$router.push({
        path: '/personalCenter/order-invoice-add',
        query: {
          orderCode: info.orderCode
        }
      })
    },
    // 评价成功
    onSuccess () {
      this.dialogVisible = false
      this.$emit('refresh')
    },
    // 订单评价
    orderEvaluate (row) {
      this.row = row
      this.dialogVisible = true
    },
    // 订单评价
    showOrderEvaluate (row) {
      this.row = row
      this.dialogVisible2 = true
    },
    detailOrderHandle (item, isToView) {
      // isToView是否滚动到定点位置
      this.$emit('detailOrderHandle', item, isToView)
    },
    cancelOrderHandle (item) {
      this.$emit('cancelOrderHandle', item)
    },
    goToPay () {
      this.$emit('goToPay', this.orderJson)
    },
    downloadContract () {
      let url = this.orderJson.payOrderContractRefactoryVo.contractUrl
      if (url) {
        window.open(url)
      } else {
        this.$message.error(this.$t('orderlist.noContract'))
      }
    },
    buyAgain () {
      let shoppingCartFormList = JSON.stringify(
        this.orderJson.payOrderItemRefactoryVos
      )
      this.$router.push({
        name: 'createOrder',
        query: {
          orderSource: '10',
          shoppingCartFormList
        }
      })
    },
    // 合并行
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // 合并行：columnIndex === xx 找到第xx列，实现合并随机出现的行数
      if (columnIndex === 4 || columnIndex === 5 || columnIndex === 6) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
      // 和并列：找到第4行，实现合并列（最多三件商品，第四行为展开控件）
      if (rowIndex === 3) {
        return [1, 4]
      }
    },
    // 因为要合并的行数是不固定的，此函数是实现合并随意行数的功能
    getSpanArr (data) {
      console.log('zmmm--', data) // 从后台获取的数据
      this.spanArr = []
      this.pos = 0
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          // 如果是第一条记录（即索引是0的时候），向数组中加入１
          this.spanArr.push(1)
          this.pos = 0
        } else {
          if (
            data[i].proMore3Len ||
            data[i].logisticsNumber === data[i - 1].logisticsNumber
          ) {
            // 如果itemCode相等就累加，并且push 0
            this.spanArr[this.pos] += 1
            this.spanArr.push(0)
          } else {
            // 不相等push 1
            this.spanArr.push(1)
            this.pos = i
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../common/buttonStyle.scss";
@import "../common/productStyle.scss";
.proMore {
  text-align: center;
  cursor: pointer;
  color: #8f8f8f;
}
.product-list >>> .el-table__body tr:nth-child(4) td:nth-child(1) {
  background: #eee;
}
</style>
